import Vue from "vue";
import Vuex from "vuex";
import {
  getToken,
  setToken,
  getSession,
  setSession,
  clearAuth,
} from "@/utils/auth";
import { login as loginApi, getProfile } from "@/api/auth";
import { mapLoginResponse, mapProfileResponse } from "./adminDefaults";

Vue.use(Vuex);

const SIDEBAR_KEY = "im_admin_sidebar_collapsed";
const savedSession = getSession();

const state = {
  token: getToken(),
  userInfo: (savedSession && savedSession.userInfo) || {},
  menus: (savedSession && savedSession.menus) || [],
  permissions: (savedSession && savedSession.permissions) || [],
  sidebarCollapsed: localStorage.getItem(SIDEBAR_KEY) === "1",
};

function persistSession(session) {
  setSession(session);
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo || {};
  },
  SET_MENUS(state, menus) {
    state.menus = menus || [];
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions || [];
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed;
    localStorage.setItem(SIDEBAR_KEY, state.sidebarCollapsed ? "1" : "0");
  },
  RESET_STATE(state) {
    state.token = "";
    state.userInfo = {};
    state.menus = [];
    state.permissions = [];
  },
};

const actions = {
  applySession({ commit }, mapped) {
    commit("SET_USER_INFO", mapped.userInfo);
    commit("SET_MENUS", mapped.menus);
    commit("SET_PERMISSIONS", mapped.permissions);
    persistSession(mapped);
  },
  async login({ commit, dispatch }, payload) {
    const data = await loginApi(payload);
    const mapped = mapLoginResponse(data);
    setToken(mapped.token);
    commit("SET_TOKEN", mapped.token);
    await dispatch("applySession", mapped);
    return mapped;
  },
  async fetchProfile({ commit, dispatch, state }) {
    if (!state.token) {
      return null;
    }
    const data = await getProfile();
    const mapped = mapProfileResponse(data);
    await dispatch("applySession", mapped);
    return mapped;
  },
  logout({ commit }) {
    clearAuth();
    commit("RESET_STATE");
  },
};

const getters = {
  hasPermission: (state) => (code) => {
    if (!code) {
      return true;
    }
    if (state.userInfo && state.userInfo.role === "admin") {
      return true;
    }
    const perms = state.permissions || [];
    if (perms.indexOf(code) !== -1) {
      return true;
    }
    if ((code === "role:view" || code === "admin:view") && perms.indexOf("rbac:view") !== -1) {
      return true;
    }
    return false;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
});
